import { Routes, Route, BrowserRouter, RouteObject } from 'react-router-dom';
import { App } from '../App';
import routes from '../../newApp/routes';

const { PUBLIC_URL } = process.env;

const renderRoutes = (routeList: RouteObject[], parentKey = 'route') =>
  routeList.map((route, index) => {
    const routeKey = `${parentKey}-${route.path ?? 'index'}-${index}`;

    if (route.index) {
      return (
        <Route
          key={routeKey}
          index
          element={route.element}
          errorElement={route.errorElement}
          handle={route.handle}
        />
      );
    }

    return (
      <Route
        key={routeKey}
        path={route.path}
        element={route.element}
        errorElement={route.errorElement}
        handle={route.handle}
      >
        {route.children ? renderRoutes(route.children, routeKey) : null}
      </Route>
    );
  });

const AppRoutes = () => {
  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>{renderRoutes(routes)}</Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
